module.exports = __webpack_public_path__ + "static/media/about24.56dff211.webp";